import { InputLabel, InputMessage } from '@econsult/econsult-ui/dist/components/Input/InputStyles';
import { SelectContainer } from '@econsult/econsult-ui/dist/components/Select/SelectStyles';
import { formInputLabelStyles, FormItemWrapper } from 'components/FormInput/style';
import styled from 'styled-components';

export const StyledFormItemWrapper = styled(FormItemWrapper)`
  & ${InputLabel} {
    ${formInputLabelStyles};
  }

  & ${InputMessage} {
    font-size: 0.75rem;
  }

  & ${SelectContainer} {
    grid-area: 2 / 1 / auto / -1;
  }
`;
